var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19131 12.9207L6.90513 10.1935C7.01897 10.0955 7.03224 9.92334 6.93473 9.80894C6.83724 9.69455 6.66592 9.68121 6.55209 9.7792C6.54148 9.78834 6.53157 9.79828 6.52249 9.80894L4.27002 12.0698L4.27002 1.27271C4.27002 1.12211 4.14851 1 3.99862 1C3.84873 1 3.72725 1.12211 3.72725 1.27271L3.72725 12.0698L1.47751 9.80894C1.38002 9.69455 1.2087 9.68121 1.09486 9.7792C0.981031 9.87719 0.967761 10.0493 1.06527 10.1637C1.07437 10.1744 1.08425 10.1844 1.09486 10.1935L3.80869 12.9207C3.9145 13.0264 4.08545 13.0264 4.19131 12.9207Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.3845be1b44b88947f58fbca36056d688.svg";
export { ForwardRef as ReactComponent };